import BadRequestError from '../status-errors/bad-request-error';

export default class BasicLoginInvalidEmail extends BadRequestError {
  public name = 'BasicLoginInvalidEmail';
  constructor(message: string) {
    super(message);
  }
}
